import { render, staticRenderFns } from "./Comercio.vue?vue&type=template&id=f01fb21c&scoped=true&"
import script from "./Comercio.vue?vue&type=script&lang=js&"
export * from "./Comercio.vue?vue&type=script&lang=js&"
import style0 from "./Comercio.vue?vue&type=style&index=0&id=f01fb21c&scoped=true&lang=css&"
import style1 from "./Comercio.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01fb21c",
  null
  
)

export default component.exports